export default {
  getCandidateDocument: (state) => state.candidateDocument,
};
